import Login from './views/Login.vue'
import NotFound from './views/404.vue'
import Home from './views/Home.vue'
let routes = [{
    path: '/login',
    component: Login,
    name: '',
    hidden: true
}, {
    path: '/404',
    component: NotFound,
    name: '',
    hidden: true
},
// {
//     path: '/demo',
//     component: r => require(['@/views/demo/demo.vue'], r),
//     name: '',
// },
{
    path: '/',
    component: Home,
    name: 'home',
    hidden: true
},
{
    path: '/print',
    component: r => require(['@/views/print/Index.vue'], r),
    hidden: true
},
{
    path: '/buying',
    component: Home,
    name: '报价',
    children: [{
        path: '/buying/index',
        component: r => require(['@/views/buying/index.vue'], r),
        name: '报价'
    }]
},
{
    path: '/index',
    component: Home,
    name: '返回首页',
    iconCls: 'fa fa-reply',
    leaf: true,
    children: [{
        path: '/index',
        component: r => require(['@/views/index/Index.vue'], r),
        name: '返回首页'
    }]
},
{
    id: 1,
    path: '/stock',
    component: Home,
    name: '产品管理',
    iconCls: 'fa fa-truck',
    children: [
        {
            id: 9,
            path: '/stock/list',
            component: r => require(['@/views/stock/list/Index.vue'], r),
            name: '产品查询',
            children: [{
                path: '/stock/list',
                component: r => require(['@/views/stock/list/pages/List.vue'], r),
                meta: { keepAlive: true }
            }, {
                path: '/stock/list/edit',
                component: r => require(['@/views/stock/list/pages/Edit.vue'], r),
                name: '基本信息',
            }, {
                path: '/stock/list/info/param',
                component: r => require(['@/views/stock/list/pages/Info.vue'], r),
                children: [{
                    path: '/stock/list/info/param',
                    component: r => require(['@/views/stock/list/components/BaseParam.vue'], r),
                    name: '基本参数',
                }, {
                    path: '/stock/list/info/modelList',
                    component: r => require(['@/views/stock/list/components/ModelsList.vue'], r),
                    name: '适配车型',
                }]
            }]
        },
        {
            id: 10,
            path: '/stock/store-goods-classify',
            component: r => require(['@/views/stock/list/pages/storeGoodsClassify/List.vue'], r),
            name: '产品分类管理'
        },
        // {
        //     id: 146,
        //     path: '/stock/sepc',
        //     component: r => require(['@/views/stock/sepc/Index.vue'], r),
        //     name: '产品EPC归类管理'
        // },
        {
            id: 167,
            path: '/stock/partsClassification',
            component: r => require(['@/views/stock/partsClassification/Index.vue'], r),
            name: '配件归类管理'
        },
        {
            id: 128,
            path: "/finance/rated/list",
            component: (r) => require(["@/views/finance/rated/Index.vue"], r),
            name: "产品定价管理",
            children: [
                {
                    path: "/finance/rated/list",
                    component: (r) => require(["@/views/finance/rated/List.vue"], r),
                    name: "产品定价管理",
                    meta: {
                        keepAlive: true,
                    },
                },
                {
                    path: "/finance/rated/soldCommodity",
                    component: (r) => require(["@/views/finance/rated/SoldCommodity.vue"], r),
                    name: "产品定价管理",
                    meta: {
                        keepAlive: false,
                    },
                },
                {
                    path: "/finance/rated/unsoldCommodity",
                    component: (r) => require(["@/views/finance/rated/UnsoldCommodity.vue"], r),
                    name: "产品定价管理",
                    meta: {
                        keepAlive: false,
                    },
                },
                {
                    path: "/finance/rated/createStepPrice",
                    component: (r) => require(["@/views/finance/rated/createStepPrice.vue"], r),
                    name: "产品定价管理",
                    meta: {
                        keepAlive: false,
                    },
                },
            ],
        },
        {
            id: 146,
            path: '/stock/codingManagement',
            component: r => require(['@/views/stock/codingManagement/Index.vue'], r),
            name: '产品归类打码管理',
            meta:  {
                keepAlive: true,
            },
        },
    ]
},
{
    id: 2,
    path: '/sales',
    component: Home,
    name: '销售管理',
    iconCls: 'fa fa-id-card-o',
    children: [
        {
            path: '/sales/billing/list',
            component: r => require(['@/views/sale/billing/Index.vue'], r),
            name: '销售开单',
            hidden: true,
            children: [{
                path: '/sales/billing/list',
                component: r => require(['@/views/sale/billing/pages/List.vue'], r),
                name: '销售开单',
            }, {
                path: '/sales/billing/edit',
                component: r => require(['@/views/sale/billing/pages/Edit.vue'], r),
                name: '销售开单',
            }, {
                path: '/sales/billing/print',
                component: r => require(['@/views/sale/billing/pages/Print.vue'], r),
                name: '打印',
            }]
        },
        {
            id: 11,
            path: '/sales/order/orderList',
            component: r => require(['@/views/sale/order/Index.vue'], r),
            name: '订单管理',
            children: [
                {
                    path: '/sales/order/orderList',
                    component: r => require(['@/views/sale/order/pages/Index.vue'], r),
                    name: '订单列表',
                },
                {
                    path: '/sales/stock/edit',
                    component: r => require(['@/views/sale/stock/pages/Edit.vue'], r),
                    name: '出库开单',
                },
                {
                    path: '/sales/stock/send',
                    component: r => require(['@/views/sale/stock/pages/Send.vue'], r),
                    name: '出库盘点',
                },
                {
                    path: '/sales/order/print',
                    component: r => require(['@/views/sale/order/pages/Print.vue'], r),
                    name: '打印',
                },
            ]
        },
        {
            id: 12,
            path: '/sales/orderQxb/orderList',
            component: r => require(['@/views/sale/orderQxb/Index.vue'], r),
            name: '订单管理（汽修宝）',
            children: [{
                path: '/sales/orderQxb/orderList',
                component: r => require(['@/views/sale/orderQxb/pages/Index.vue'], r),
                name: '订单管理（汽修宝）',
            }]
        },
        {
            id: 13,
            path: '/sales/orderAdmin/orderList',
            component: r => require(['@/views/sale/orderAdmin/Index.vue'], r),
            name: '订单管理（加盟店）',
            children: [
                {
                    path: '/sales/orderAdmin/orderList',
                    component: r => require(['@/views/sale/orderAdmin/pages/Index.vue'], r),
                    name: '订单列表',
                    children: [{
                        path: '/sales/orderAdmin/orderList',
                        component: r => require(['@/views/sale/orderAdmin/pages/OrderList.vue'], r),
                        name: '订单列表'
                    }],
                },
                {
                    path: '/sales/orderAdmin/orderDetail',
                    component: r => require(['@/views/sale/orderAdmin/pages/Index.vue'], r),
                    name: '订单明细',
                    children: [{
                        path: '/sales/orderAdmin/orderDetail',
                        component: r => require(['@/views/sale/orderAdmin/pages/OrderDetail.vue'], r),
                        name: '订单明细'
                    }],
                },
                {
                    path: '/sales/orderAdmin/orderList/orderInfo',
                    component: r => require(['@/views/sale/orderAdmin/pages/OrderInfo.vue'], r),
                    name: '订单详情',
                    hidden: true
                }
            ]
        },
        {
            id: 14,
            path: '/sales/return/list',
            component: r => require(['@/views/sale/return/Index.vue'], r),
            name: '销售退货管理',
            children: [{
                path: '/sales/return/list',
                component: r => require(['@/views/sale/return/pages/List.vue'], r),
                name: '销售退货',
            }, {
                path: '/sales/return/edit',
                component: r => require(['@/views/sale/return/pages/Edit.vue'], r),
                name: '退货开单',
            }, {
                path: '/sales/return/print',
                component: r => require(['@/views/sale/return/pages/Print.vue'], r),
                name: '打印',
            }]
        },
        {
            id: 73,
            path: '/sales/refund/list',
            component: r => require(['@/views/sale/refund/Index.vue'], r),
            name: '退款/退货管理（商城）',
            children: [{
                path: '/sales/refund/list',
                component: r => require(['@/views/sale/refund/pages/List.vue'], r),
                name: '退款退货',
                // meta: { keepAlive:true }
            }, {
                path: '/sales/refund/edit',
                component: r => require(['@/views/sale/refund/pages/Edit.vue'], r),
                name: '售后管理-售后详情',
            }]
        },
    ]
},
{
    id: 3,
    path: '/inventory',
    component: Home,
    name: '库存管理',
    iconCls: 'fa fa-folder',
    children: [
        {
            id: 15,
            path: '/inventory/search/list',
            component: r => require(['@/views/inventory/search/Index.vue'], r),
            name: '库存查询',
            children: [{
                path: '/inventory/search/list',
                component: r => require(['@/views/inventory/search/pages/List.vue'], r),
                name: '库存列表'
            }, {
                path: '/inventory/search/preview',
                component: r => require(['@/views/inventory/search/pages/Preview.vue'], r),
                name: '库存概览'
            }, {
                path: '/inventory/search/statistical',
                component: r => require(['@/views/inventory/search/pages/Statistical.vue'], r),
                name: '出入库统计'
            }, {
                path: '/inventory/search/inOutDetail',
                component: r => require(['@/views/inventory/search/pages/InOutDetail.vue'], r),
                name: '出入库明细'
            }, {
                path: '/inventory/search/adjustDetail',
                component: r => require(['@/views/inventory/search/pages/AdjustDetail.vue'], r),
                name: '调仓明细'
            }]
        },
        {
            id: 16,
            path: '/sales/purchase/list',
            component: r => require(['@/views/sale/purchase/Index.vue'], r),
            name: '进货入库管理',
            children: [{
                path: '/sales/purchase/list',
                component: r => require(['@/views/sale/purchase/pages/List.vue'], r),
                name: '配件进货',
            }, {
                path: '/sales/purchase/edit',
                component: r => require(['@/views/sale/purchase/pages/Edit.vue'], r),
                name: '配件进货',
            }, {
                path: '/sales/purchase/print',
                component: r => require(['@/views/sale/purchase/pages/Print.vue'], r),
                name: '打印',
            }]
        },
        {
            id: 17,
            path: '/inventory/Management/inventoryList',
            component: r => require(['@/views/inventory/management/Index.vue'], r),
            name: '仓库仓位管理',
            children: [{
                path: '/inventory/Management/inventoryList',
                component: r => require(['@/views/inventory/management/pages/InventoryList.vue'], r),
                name: '仓库列表'
            }, {
                path: '/inventory/Management/positionsList',
                component: r => require(['@/views/inventory/management/pages/PositionsList.vue'], r),
                name: '仓位列表',
                hidden: true
            }]
        },
        {
            id: 18,
            path: '/inventory/logis',
            component: r => require(['@/views/inventory/logis/Index.vue'], r),
            name: '物流管理',
            children: [{
                path: '',
                component: r => require(['@/views/inventory/logis/pages/logisList.vue'], r),
                name: '物流列表'
            }]
        },
        {
            id: 19,
            path: '/inventory/takeStock/takeStockPlan',
            component: r => require(['@/views/inventory/takeStock/Index.vue'], r),
            name: '库存盘点',
            children: [{
                path: '/inventory/takeStock/takeStockPlan',
                component: r => require(['@/views/inventory/takeStock/pages/takeStockPlan.vue'], r),
                name: '库存盘点计划'
            }]
        },
        {
            // 174
            id: 174,
            path: '/inventory/transferPositions',
            component: r => require(['@/views/inventory/transferPositions/Index.vue'], r),
            name: '调仓调拨管理',
            children: [{
                path: '/inventory/transferPositions',
                component: r => require(['@/views/inventory/transferPositions/Manage.vue'], r),
                name: '调仓调拨管理',
                meta: { keepAlive: true }
            },{
                path: '/inventory/transferPositions/create',
                component: r => require(['@/views/inventory/transferPositions/Create.vue'], r),
                name: '新增调拨'
            },{
                path: '/inventory/transferPositions/detail',
                component: r => require(['@/views/inventory/transferPositions/TransferDetail.vue'], r),
                name: '调拨详情'
            },{
                path: '/inventory/transferPositions/print',
                component: r => require(['@/views/inventory/transferPositions/Print.vue'], r),
                name: '打印'
            }]
        },
        {
            id: 188,
            path: '/inventory/transferWarehouse',
            component: r => require(['@/views/inventory/transferWarehouse/Index.vue'], r),
            name: '调仓盘点管理',
        },
    ]
},
{
    id: 4,
    path: '/user-manage',
    component: Home,
    name: '客户管理',
    iconCls: 'fa fa-user-circle',
    children: [
        {
            id: 20,
            path: '/user-manage/user-list/list',
            component: r => require(['@/views/user-manage/Index.vue'], r),
            name: '客户/供应商查询',
            children: [{
                path: '/user-manage/user-list/list',
                component: r => require(['@/views/user-manage/pages/user-list/List.vue'], r),
                name: '客户/供应商查询'
            }]
        },
        {
            id: 191,
            path: "/user-manage/user-custom",
            component: (r) => require(["@/views/user-manage/pages/user-custom/index.vue"], r),
            name: "客户运营管理",
            children: [{
                path: "/user-manage/user-custom",
                component: (r) => require(["@/views/user-manage/pages/user-custom/list.vue"], r),
                name: "客户运营管理",
            }],
        },
        {
            id: 21,
            path: '/user-manage/user-set/set',
            component: r => require(['@/views/user-manage/pages/user-set/index.vue'], r),
            name: '客户设置',
            children: [{
                path: '/user-manage/user-list/set',
                component: r => require(['@/views/user-manage/pages/user-set/index.vue'], r),
                name: '客户设置'
            }]
        },
        {
            id: 137,
            path: '/user-manage/business-management',
            component: r => require(['@/views/user-manage/pages/business-management/index.vue'], r),
            name: '企业管理',
            children: [{
                path: '/user-manage/business-management',
                component: r => require(['@/views/user-manage/pages/business-management/list.vue'], r),
                name: '企业管理列表'
            }]
        }
    ]
},
{
    id: 90,
    path: '/league',
    component: Home,
    name: '联盟/连锁管理',
    iconCls: 'fa fa-sitemap',
    children: [
        {
            id: 92,
            path: '/league/list',
            component: r => require(['@/views/league/list/index.vue'], r),
            name: '我的联盟/连锁',
        },
        {
            id: 97,
            path: '/league/deliver',
            component: r => require(['@/views/league/deliver/index.vue'], r),
            name: '联盟发货员管理',
        },
        {
            id: 98,
            path: '/league/record',
            component: r => require(['@/views/league/record/index.vue'], r),
            name: '发货服务记录',
        },
        {
            id: 91,
            path: '/league/stock',
            component: r => require(['@/views/league/stock/Index.vue'], r),
            name: '采购管理',
            children: [
                {
                    path: '/league/stock',
                    component: r => require(['@/views/league/stock/pages/Index.vue'], r),
                    name: '采购管理',
                },
                {
                    path: '/league/stock/list',
                    component: r => require(['@/views/league/stock/pages/List.vue'], r),
                    name: '采购管理',
                },
                {
                    path: '/league/stock/edit',
                    component: r => require(['@/views/league/stock/pages/Edit.vue'], r),
                    name: '采购管理',
                }
            ]
        },
    ]
},
{
    id: 5,
    path: '/finance',
    component: Home,
    name: '财务管理',
    iconCls: 'fa fa-gg-circle',
    children: [
        {
            id: 22,
            path: '/finance/list',
            component: r => require(['@/views/finance/List.vue'], r),
            name: '应收/应付账管理'
        },
        {
            id: 76,
            path: '/finance/index',
            component: r => require(['@/views/finance/Index.vue'], r),
            name: '财务收支明细管理'
        },
        // {
        //     id: 116,
        //     path: '/finance/marketingStats',
        //     component: r => require(['@/views/finance/marketingStats.vue'], r),
        //     name: '进销存营销统计'
        // },
        {
            id: 116,
            path: '/finance/purchase/list',
            component: r => require(['@/views/finance/purchase/Index.vue'], r),
            name: '采购明细管理',
            children: [
                {
                    path: '/finance/purchase/list',
                    component: r => require(['@/views/finance/purchase/PurchaseList.vue'], r),
                    name: '采购明细管理',
                    meta: {
                        keepAlive: true
                    }
                },
                {
                    path: '/finance/purchase/wholeInfo',
                    component: r => require(['@/views/finance/purchase/WholeInfo.vue'], r),
                    name: '整单详情'
                },
                {
                    path: '/finance/purchase/branchInfo',
                    component: r => require(['@/views/finance/purchase/BranchInfo.vue'], r),
                    name: '分单详情'
                }
            ]
        },
        {
            id: 169,
            path: '/finance/achievement/list',
            component: r => require(['@/views/finance/achievement/Index.vue'], r),
            name: '销售业绩统计'
        },
        {
            id: 194,
            path: "/finance/livePayOrderList/list",
            component: (r) => require(["@/views/finance/livePayOrderList.vue"], r),
            name: "收款流水管理",
        }
    ]
},
{
    id: 6,
    path: '/store',
    component: Home,
    name: '网店管理',
    iconCls: 'fa fa-university',
    children: [
        {
            id: 23,
            path: '/stock/store-setting',
            component: r => require(['@/views/stock/list/pages/storeSetting/Index.vue'], r),
            name: '网店设置'
        },
        {
            id: 24,
            path: '/store/store-maintain/index',
            component: r => require(['@/views/store/Index.vue'], r),
            name: '网店装修',
            children: [{
                path: '/store/store-maintain/index',
                component: r => require(['@/views/store/pages/store-maintain/index.vue'], r),
                name: '网店装修'
            }]
        },
        {
            path: '/store/store-design/index',
            component: r => require(['@/views/store/Index.vue'], r),
            name: '网店装修（商城）',
            children: [{
                path: '/store/store-design/index',
                component: r => require(['@/views/store/pages/store-design/index.vue'], r),
                name: '网店装修（商城）'
            }]
        },
        {
            id: 25,
            path: '/store/store-article/index',
            component: r => require(['@/views/store/Index.vue'], r),
            name: '资讯发布管理',
            children: [{
                path: '/store/store-article/index',
                component: r => require(['@/views/store/pages/store-article/list.vue'], r),
                name: '资讯发布管理'
            }]
        },
        {
            id: 78,
            path: '/store/article-sort/index',
            component: r => require(['@/views/store/Index.vue'], r),
            name: '资讯分类',
            children: [{
                path: '/store/article-sort/index',
                component: r => require(['@/views/store/pages/article-sort/index.vue'], r),
                name: '资讯分类'
            }]
        },
        {
            id: 26,
            path: '/store/store-service/index',
            component: r => require(['@/views/store/Index.vue'], r),
            name: '客服及帮助中心',
            children: [{
                path: '/store/store-service/index',
                component: r => require(['@/views/store/pages/store-service/index.vue'], r),
                name: '客服及帮助中心'
            }]
        },
        {
            id: 79,
            path: '/store/application-center/index',
            component: r => require(['@/views/store/Index.vue'], r),
            name: '应用中心',
            children: [
                {
                    path: '/store/application-center/index',
                    component: r => require(['@/views/store/pages/application-center/Index.vue'], r),
                    name: '应用中心'
                },
                {
                    path: '/store/periodic-maintenance/index',
                    component: r => require(['@/views/store/pages/application-center/periodic-maintenance/Index.vue'], r),
                    name: '周期保养'
                },
                {
                    path: '/store/structure-selection/index',
                    component: r => require(['@/views/store/pages/application-center/structure-selection/Index.vue'], r),
                    name: '结构选品'
                },
                {
                    path: '/store/structure-selection/part',
                    component: r => require(['@/views/store/pages/application-center/structure-selection/part.vue'], r),
                    name: '部位'
                },
                {
                    path: '/store/structure-selection/product',
                    component: r => require(['@/views/store/pages/application-center/structure-selection/product.vue'], r),
                    name: '产品'
                },
                {
                    path: '/store/nearby-store/index',
                    component: r => require(['@/views/store/pages/application-center/nearby-store/Index.vue'], r),
                    name: '附近门店'
                },
            ]
        }
    ]
},
{
    id: 7,
    path: '/system',
    component: Home,
    name: '系统设置',
    iconCls: 'fa fa-cog',
    children: [
        {
            id: 27,
            path: '/store/store-set/index',
            component: r => require(['@/views/store/Index.vue'], r),
            name: '店铺信息',
            children: [{
                path: '/store/store-set/index',
                component: r => require(['@/views/store/pages/store-set/index.vue'], r),
                name: '店铺信息'
            }]
        },
        {
            id: 28,
            path: '/inventory/takeStock/stockSync',
            component: r => require(['@/views/inventory/stockSync/Index.vue'], r),
            name: '电商平台对接'
        },
        {
            id: 29,
            path: '/sales/settings/settings',
            component: r => require(['@/views/sale/settings/settings.vue'], r),
            name: '进销存功能设置',
        },
        {
            id: 30,
            path: '/sales/staff',
            component: r => require(['@/views/system/staff/index.vue'], r),
            name: '员工账号管理',
        },
        {
            id: 31,
            path: '/system/role',
            component: r => require(['@/views/system/role/Index.vue'], r),
            name: '账号角色权限管理'
        },
        {
            id: 165,
            path: '/store/robotQuote',
            component: r => require(['@/views/store/pages/robotQuote/index.vue'], r),
            name: '微信自动报价配置'
        },
    ]
},
{
    id: 204,
    path: '/dataBoard',
    component: Home,
    name: '数据看板',
    iconCls: 'fa fa-cog',
    children: [
        {
            id: 205,
            path: '/dataBoard/index',
            component: r => require(['@/views/dataBoard/index.vue'], r),
            name: '车型覆盖率',
            children: [{
                path: '/dataBoard/index',
                component: r => require(['@/views/dataBoard/model-rate/index.vue'], r),
                name: '车型覆盖率'
            }]
        },
        {
            id: 227,
            path: '/dataBoard/operationBoard',
            component: r => require(['@/views/dataBoard/operationBoard.vue'], r),
            name: '运营看板',
            meta: { noMargin: true }
        }
    ]
},
{
    id: 231,
    path: '/dataBoard1',
    component: Home,
    name: '数据看板1',
    iconCls: 'fa fa-bar-chart',
    children: [
        {
            id: 225,
            path: '/dataBoard1/scrapFactory',
            component: r => require(['@/views/dataBoard/scrapFactory.vue'], r),
            name: '报废厂看板',
            meta: { noMargin: true }
        },
        {
            id: 226,
            path: '/dataBoard1/warehouseScreen',
            component: r => require(['@/views/dataBoard/warehouseScreen.vue'], r),
            name: '仓库大屏',
            meta: { fullscreen: true }
        }
    ]
},
{
    path: '*',
    hidden: true,
    redirect: {
        path: '/404'
    }
}
];

export default routes;




// WEBPACK FOOTER //
// ./src/routes.js